import type { FaireProductEntity } from "../../entity_types/product";

export const p_dxu5evkeme: FaireProductEntity = {
  token: "p_dxu5evkeme",
  type: "product",
  name: "Shungite Sphere - 40mm",
  brandToken: "b_eqykpyrhjx",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/fca5639ebc7861137f0f060954884710e1d86a762e13b465f9188408adeb8d8e.jpeg",
  galleryImageUrls: [],
  priceDollars: 23.48,
  description:
    "Shungite prepares one for light body activation, cleansing, balancing and aligning all the particles of the body. It is a stone of truth, amplifying the discomfort connected with falsehood or negativity. Shungite's purifying influence can rid one of negative emotional patterns. Shungite is an excellent choice of stone used for deflecting EMF.\n\nAffirmation: I open myself to absolute purification, into the entry of the light into every atom of my being.\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n",
  tags: [],
  msrpDollars: 46.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:29.066Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
